import { createVuetify } from 'vuetify';
import { fr, en, it } from 'vuetify/locale';
import { monacoDark, monacoDefaults, monacoKiosk, monacoLight } from '@common/plugins/vuetify/MonacoTheme';

import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';
import '@/assets/scss/main.scss';

/**
 * Trois thèmes pour trois contextes d'usage.
 *
 * `monacoKiosk` reprend la palette claire mais est appliqué avec des tailles
 * agrandies ; `monacoDark` sert au mode conduite, l'application chauffeur
 * restant allumée de nuit sur un support de pare-brise.
 */
export default createVuetify({
	locale: {
		locale: 'fr',
		fallback: 'fr',
		messages: { fr, en, it },
	},
	theme: {
		defaultTheme: 'monacoLight',
		themes: {
			monacoLight,
			monacoDark,
			monacoKiosk,
		},
	},
	defaults: monacoDefaults,
	icons: { defaultSet: 'mdi' },
});
